<div class="p-grid p-jc-center">
    <div class="p-col-6">
        <div class="p-grid">
        <div class="p-col-12">
            <span class="ui-float-label">
                <input  id="email" class="w-100" type="text " pInputText [(ngModel)]="email" name="email " required />
                <label for="email">{{'GLOBAL.EMAIL' | translate}}</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="ui-float-label">
                <input  id="password" class="w-100" weakLabel="Debil" mediumLabel="Medio" strongLabel="Fuerte"
                type="password" pPassword [(ngModel)]="password" name="password " required />
                <label for="password">{{'GLOBAL.CONTRASEÑA' | translate}}</label>
            </span>
        </div>
        <div class="p-col-12">
            <span class="ui-float-label">
                <input id="repeatPassword" weakLabel="Debil" mediumLabel="Medio" strongLabel="Fuerte"
                 class="w-100" type="password" pPassword [(ngModel)]="repeatPassword" name="repeatPassword " required />
                <label for="repeatPassword">{{'GLOBAL.REPETIR.CONTRASEÑA' | translate}}</label>
            </span>
        </div>
        <div class="p-col-12">
            <button class="pr-2 pl-2 pb-1 pt-1 "
            [disabled]="password !== repeatPassword && email"
             type="submit "
             pButton [label]=" 'GLOBAL.ENVIAR' | translate "
             (click)="restore() "></button>
        </div>
    </div>
    </div>
</div>
<dum-toast #dumToast></dum-toast>
